import React, { useState, useEffect } from 'react';
import { Badge } from './ui/badge';
import apiService from '../services/api';

const Technologies = () => {
  const [technologies, setTechnologies] = useState([]);

  useEffect(() => {
    const fetchTechnologies = async () => {
      const data = await apiService.getTechnologies();
      setTechnologies(data);
    };
    fetchTechnologies();
  }, []);

  return (
    <section id="technologies" className="py-24 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-5xl lg:text-6xl font-light tracking-tight text-gray-900 mb-6">
            Technologies
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            We work with cutting-edge tools and frameworks to build robust, scalable solutions.
          </p>
        </div>

        {/* Technologies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {technologies.map((tech, index) => (
            <div
              key={tech.id}
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-gray-900 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <h3 className="text-2xl font-normal text-gray-900 mb-6">
                {tech.category}
              </h3>
              <div className="flex flex-wrap gap-3">
                {tech.items.map((item, idx) => (
                  <Badge
                    key={idx}
                    variant="secondary"
                    className="px-4 py-2 text-sm bg-gradient-to-r from-blue-50 to-indigo-50 text-gray-700 hover:from-blue-100 hover:to-indigo-100 border border-gray-200 transition-colors duration-200"
                  >
                    {item}
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;